export const API_BASE = process.env.REACT_APP_API_BASE_URL;
export const CLIENT_ID = process.env.REACT_APP_BACK_CLIENT_ID;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = process.env.REACT_APP_SENTRY_ENVIRONMENT;
